import { BlockWidget } from '@/components/widgets/BlockWidget';
import { EventType } from '@/models/Interaction';
import { getChatAPI } from '@/api/ChatApi';
import { getCurrentThread } from '@/store/reducers/UIState';
import { MessageId } from '@/models/Message';
import { openReaderWidget } from '@/store/actionCreators/WidgetActions';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { WidgetEvent, WidgetType } from '@/models/PanelWidgets';

import { BoundingBox } from '@allenai/pdf-components/src/components/types/boundingBox'; // eslint-disable-line import/no-unresolved
import { Button, styled } from '@mui/material'; // eslint-disable-line import/no-unresolved
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

type ExcerptWidgetProps = {
  text: string;
  corpusId: number;
  messageId: MessageId;
  highlights?: BoundingBox[];
  sectionTitle?: string | null;
  className?: string;
};

export function ExcerptWidget({
  text,
  corpusId,
  messageId,
  highlights,
  sectionTitle,
  className,
}: ExcerptWidgetProps) {
  const chatApi = getChatAPI();
  const dispatch = useAppDispatch();
  const currentThread = useAppSelector(getCurrentThread);
  const openReader = (): void => {
    if (!currentThread) {
      return;
    }

    dispatch(
      openReaderWidget({
        currentThreadId: currentThread.id,
        corpusId,
        highlights,
      }),
    );

    chatApi.trackEvent({
      type: EventType.UI_INTERACTION,
      threadId: currentThread.id,
      messageId: messageId,
      data: {
        widget_type: WidgetType.READER,
        event_type: WidgetEvent.WIDGET_OPEN,
      },
    });
  };

  return (
    <ExcerptContainer>
      <BlockWidget
        text={text}
        className={className}
        actions={
          <Button
            onClick={openReader}
            size="small"
            data-testid="excerpt-reader-button"
          >
            {sectionTitle ?? 'View in paper'} <ArrowForwardIcon />
          </Button>
        }
      />
    </ExcerptContainer>
  );
}

const ExcerptContainer = styled('div')`
  margin-top: ${({ theme }) => theme.spacing(1.5)};
`;
